import React from 'react';
import { Box, Container } from '@mui/material';

interface SectionWrapperProps {
  id: string;
  children: React.ReactNode;
  dark?: boolean;
  maxWidth?: 'sm' | 'md' | 'lg' | 'xl';
  sx?: object;
}

const SectionWrapper: React.FC<SectionWrapperProps> = ({
  id,
  children,
  dark = false,
  maxWidth = 'lg',
  sx,
}) => (
  <Box
    id={id}
    component="section"
    sx={{
      py: { xs: 10, md: 16 },
      bgcolor: dark ? '#0c0c0c' : '#111111',
      ...sx,
    }}
  >
    <Container maxWidth={maxWidth}>{children}</Container>
  </Box>
);

export default SectionWrapper;
